import type React from "react";
import { useHasMousePointer } from "../../../hooks/use-is-screensize";
import { cn } from "@babybjorn/ui";
import * as s from "./HoverImageSwap.module.scss";

type HoverImageSwapProps = {
	imageNode: React.ReactNode;
	hover?: boolean;
	hoverImageNode?: React.ReactNode;
};

const HoverImageSwap: React.FC<HoverImageSwapProps> = ({
	imageNode,
	hover,
	hoverImageNode,
}) => {
	const hasMousePointer = useHasMousePointer();
	return (
		<div
			className={cn(s.imgContainer, {
				[s.hasAltImage]: hoverImageNode && hasMousePointer,
				[s.hover]: hover && hasMousePointer,
			})}
		>
			{imageNode}
			{hasMousePointer && hoverImageNode && hoverImageNode}
		</div>
	);
};

export default HoverImageSwap;
